import { version } from "react";

const config={
    apiBaseURL:process.env.REACT_APP_API_BASE_URL,
    version:process.env.REACT_APP_VERSION,
    enableLogs:process.env.REACT_APP_ENABLE_LOGS,
    env:process.env.REACT_APP_ENV


}

export default config;
